// api/appCustoms.js
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export async function getAppCustoms() {
    const res = await axios({
        url: [API, "/api-admin/v2/app-customization"].join(""),
        method: "GET",
        withCredentials: true,
    });
    return Array.isArray(res.data?.data) ? res.data.data : [];
}

export async function updateAppCustomByKey(key, value) {
    const res = await axios({
        url: [API, "/api-admin/v2/app-customization-update"].join(""),
        method: "POST",
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
        data: { key, value },
    });
    return res.data?.data || null;
}
